export const legacyBlogCategories = [
  { tag: "comprar-casa", label: "Comprar casa" },
  { tag: "vender-propiedad", label: "Vender propiedad" },
  { tag: "rentar", label: "Rentar" },
  { tag: "financiamiento", label: "Financiamiento" },
  { tag: "nuevas-construcciones", label: "Nuevas construcciones" },
  { tag: "general", label: "Blog general" },
] as const;

export type LegacyBlogCategoryTag = (typeof legacyBlogCategories)[number]["tag"];
